export default "__VITE_ASSET__d93eff68__"